import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { EmptyState as DefaultEmptyState } from 'shared/components';

const EmptyState = () => {
  const { t } = useContext(ConfigContext);
  return <DefaultEmptyState text={t('noRequests')} />;
};

export default EmptyState;
